import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { IMFieldItem, IMFieldPickerMode } from './typings';

@Component({
  selector: 'm-field-picker',
  template: `
    <div class="m-field-picker">
      <div class="m-field-picker-header" *ngIf="mHeader">
        <ng-container *nzStringTemplateOutlet="mHeader">{{ mHeader }}</ng-container>
      </div>
      <div class="m-field-picker-search" *ngIf="mShowSearch">
        <m-search-input placeholder="请搜索字段标签" [(query)]="query" (search)="onSearch()"></m-search-input>
      </div>
      <div class="m-field-picker-content">
        <ng-container *ngFor="let tag of filterTags">
          <div *ngIf="mMode === 'stretch'" class="m-field-picker-block">
            <m-field-item [tag]="tag" (click)="mSelectChange.emit(tag)"></m-field-item>
          </div>
          <m-field-item *ngIf="mMode === 'compact'" [tag]="tag" (click)="mSelectChange.emit(tag)"></m-field-item>
        </ng-container>
        <input
          #inputElementRef
          nz-input
          *ngIf="inputVisible"
          type="text"
          class="m-field-picker-input"
          [(ngModel)]="inputValue"
          [style.width.px]="90"
          (blur)="handleInputConfirm()"
          (keydown.enter)="handleInputConfirm()"
          autofocus
        />
        <div class="m-field-picker-empty" *ngIf="!filterTags.length">暂无数据</div>
        <button
          class="m-field-picker-add-btn"
          *ngIf="mCreatable && !inputVisible"
          nz-button
          nzSize="small"
          nzType="dashed"
          (click)="onCreate()"
        >
          <i nz-icon nzType="plus"></i>
          新增标签
        </button>
      </div>
      <div class="m-field-picker-footer" *ngIf="mFooter">
        <ng-container *nzStringTemplateOutlet="mFooter">{{ mFooter }}</ng-container>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class MFieldPickerComponent implements OnChanges {
  @Input() mHeader?: string | TemplateRef<void>;
  @Input() mFooter?: string | TemplateRef<void>;
  @Input() mShowSearch = true;
  @Input() mMode: IMFieldPickerMode = 'compact';
  @Input() mFields: IMFieldItem[] = [];
  @Input() mCreatable = false;
  @Input() mDefaultColor = 'rgb(0, 34, 255)';

  @Output() readonly mSelectChange = new EventEmitter<IMFieldItem>();
  @Output() readonly mFieldsChange = new EventEmitter<IMFieldItem[]>();

  @ViewChild('inputElementRef') inputElementRef!: ElementRef<HTMLInputElement>;

  inputValue = '';
  inputVisible = false;
  filterTags: IMFieldItem[] = [];
  query = '';

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { mFields } = changes;
    if (mFields) {
      this.onSearch();
    }
  }

  onSearch(): void {
    this.filterTags = this.mFields.filter(t => t.name.toUpperCase().includes(this.query.toUpperCase()));
  }

  onCreate(): void {
    this.inputVisible = true;
    this.cdr.detectChanges();
    this.inputElementRef?.nativeElement.focus();
  }

  handleInputConfirm(): void {
    if (this.inputValue && this.mFields.map(e => e.name).indexOf(this.inputValue) === -1) {
      this.mFields.push({
        name: this.inputValue,
        color: this.mDefaultColor
      });
      this.onSearch();
      this.mFieldsChange.emit(this.mFields);
    }
    this.inputValue = '';
    this.inputVisible = false;
  }
}
